type Props = { width?: number; height?: number; fill?: string };
const EngagedIcon = ({ width = 40, height = 40, fill = "none" }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 150 185"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#000000"
        stroke-opacity="0.00"
        stroke-width="0.3"
      >
        <path d="M 0.00 104.00 C 8.86 102.30 14.96 92.20 24.00 91.00 C 24.33 90.96 26.80 90.79 27.00 91.00 C 25.99 81.66 27.30 73.68 25.01 63.99 C 22.71 54.31 15.77 54.72 13.22 44.78 C 10.68 34.83 23.47 33.60 30.00 35.00 C 34.91 36.05 39.31 36.68 43.23 39.77 C 47.15 42.86 48.49 47.17 51.32 49.68 C 54.15 52.19 56.14 60.38 59.00 61.00 C 68.17 54.32 76.81 50.97 86.23 44.23 C 95.65 37.49 104.61 31.11 116.00 33.00 C 120.54 33.75 124.62 33.56 128.00 38.00 L 128.00 0.00 L 74.00 0.00 C 74.44 6.46 80.21 28.59 70.00 29.00 C 62.57 29.30 63.92 22.20 64.22 16.78 C 64.52 11.36 63.49 3.96 67.00 0.00 L 0.00 0.00 L 0.00 104.00 M 54.00 38.00 C 47.32 38.89 45.11 30.28 42.08 25.92 C 39.05 21.56 33.10 12.22 42.00 12.00 C 48.39 11.84 50.69 19.39 53.25 23.75 C 55.82 28.10 61.61 36.99 54.00 38.00 M 87.00 38.00 C 77.88 37.77 83.74 29.31 86.75 24.75 C 89.77 20.19 91.09 11.86 98.00 12.00 C 106.53 12.17 101.02 20.79 98.08 25.08 C 95.13 29.36 93.91 38.17 87.00 38.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FCCE40"
        stroke-opacity="0.90"
        stroke-width="0.3"
      >
        <path d="M 70.00 29.00 C 73.69 27.16 70.50 18.81 71.00 15.00 C 71.50 11.19 71.96 3.35 70.00 0.00 L 67.00 0.00 C 63.49 3.96 64.52 11.36 64.22 16.78 C 63.92 22.20 62.57 29.30 70.00 29.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#BB4D03"
        stroke-opacity="0.85"
        stroke-width="0.3"
      >
        <path d="M 70.00 29.00 C 80.21 28.59 74.44 6.46 74.00 0.00 L 70.00 0.00 C 71.96 3.35 71.50 11.19 71.00 15.00 C 70.50 18.81 73.69 27.16 70.00 29.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FCCE3F"
        stroke-opacity="0.89"
        stroke-width="0.3"
      >
        <path d="M 54.00 38.00 C 54.20 34.13 51.86 26.57 49.08 23.92 C 46.29 21.28 45.32 13.06 42.00 12.00 C 33.10 12.22 39.05 21.56 42.08 25.92 C 45.11 30.28 47.32 38.89 54.00 38.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#BA4C03"
        stroke-opacity="0.83"
        stroke-width="0.3"
      >
        <path d="M 54.00 38.00 C 61.61 36.99 55.82 28.10 53.25 23.75 C 50.69 19.39 48.39 11.84 42.00 12.00 C 45.32 13.06 46.29 21.28 49.08 23.92 C 51.86 26.57 54.20 34.13 54.00 38.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FCCD3F"
        stroke-opacity="0.89"
        stroke-width="0.3"
      >
        <path d="M 87.00 38.00 C 88.68 37.25 92.01 27.60 93.77 25.77 C 95.53 23.94 101.20 13.98 98.00 12.00 C 91.09 11.86 89.77 20.19 86.75 24.75 C 83.74 29.31 77.88 37.77 87.00 38.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B94C02"
        stroke-opacity="0.79"
        stroke-width="0.3"
      >
        <path d="M 87.00 38.00 C 93.91 38.17 95.13 29.36 98.08 25.08 C 101.02 20.79 106.53 12.17 98.00 12.00 C 101.20 13.98 95.53 23.94 93.77 25.77 C 92.01 27.60 88.68 37.25 87.00 38.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#ECAD88"
        stroke-opacity="0.98"
        stroke-width="0.3"
      >
        <path d="M 59.00 61.00 C 52.83 65.49 53.85 67.91 49.22 59.78 C 44.59 51.64 38.76 40.04 30.00 35.00 C 23.47 33.60 10.68 34.83 13.22 44.78 C 15.77 54.72 22.71 54.31 25.01 63.99 C 27.30 73.68 25.99 81.66 27.00 91.00 C 27.05 91.49 27.00 92.00 27.00 92.00 C 33.31 96.11 39.67 105.72 44.08 111.92 C 48.49 118.11 57.63 125.22 61.00 132.00 C 71.19 134.61 82.50 122.24 90.75 118.75 C 98.99 115.25 114.67 104.57 102.00 97.00 C 105.72 91.81 104.09 83.98 98.00 81.00 C 100.99 74.98 97.07 66.19 90.00 66.00 C 98.32 55.18 126.78 50.81 116.00 33.00 C 104.61 31.11 95.65 37.49 86.23 44.23 C 76.81 50.97 68.17 54.32 59.00 61.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B74803"
        stroke-opacity="0.91"
        stroke-width="0.3"
      >
        <path d="M 61.00 132.00 C 64.54 139.14 46.88 148.49 41.00 151.00 C 40.78 152.33 41.74 152.83 42.00 154.00 L 44.00 154.00 C 44.47 152.66 47.58 152.43 48.00 154.00 L 49.00 154.00 C 55.13 147.32 72.45 145.34 71.00 135.00 C 70.14 134.70 69.15 133.95 69.00 133.00 C 70.00 133.11 71.73 132.53 72.00 134.00 C 81.18 130.68 92.89 127.25 100.89 120.89 C 108.90 114.54 123.92 108.63 112.00 98.00 C 114.63 92.71 114.15 85.49 108.00 83.00 C 109.38 76.85 107.34 69.81 101.00 67.00 C 109.16 59.61 120.80 55.49 128.00 47.00 L 128.00 45.00 C 126.57 43.97 126.31 39.96 128.00 39.00 L 128.00 38.00 C 124.62 33.56 120.54 33.75 116.00 33.00 C 126.78 50.81 98.32 55.18 90.00 66.00 C 97.07 66.19 100.99 74.98 98.00 81.00 C 104.09 83.98 105.72 91.81 102.00 97.00 C 114.67 104.57 98.99 115.25 90.75 118.75 C 82.50 122.24 71.19 134.61 61.00 132.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B84904"
        stroke-opacity="0.90"
        stroke-width="0.3"
      >
        <path d="M 59.00 61.00 C 56.14 60.38 54.15 52.19 51.32 49.68 C 48.49 47.17 47.15 42.86 43.23 39.77 C 39.31 36.68 34.91 36.05 30.00 35.00 C 38.76 40.04 44.59 51.64 49.22 59.78 C 53.85 67.91 52.83 65.49 59.00 61.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B64601"
        stroke-opacity="0.67"
        stroke-width="0.3"
      >
        <path d="M 128.00 45.00 L 128.00 39.00 C 126.31 39.96 126.57 43.97 128.00 45.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#000000"
        stroke-opacity="0.00"
        stroke-width="0.3"
      >
        <path d="M 72.00 134.00 C 71.65 134.13 70.96 134.69 71.00 135.00 C 72.45 145.34 55.13 147.32 49.00 154.00 L 128.00 154.00 L 128.00 47.00 C 120.80 55.49 109.16 59.61 101.00 67.00 C 107.34 69.81 109.38 76.85 108.00 83.00 C 114.15 85.49 114.63 92.71 112.00 98.00 C 123.92 108.63 108.90 114.54 100.89 120.89 C 92.89 127.25 81.18 130.68 72.00 134.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E77723"
        stroke-opacity="0.97"
        stroke-width="0.3"
      >
        <path d="M 0.00 104.00 L 0.00 111.00 C 6.70 117.02 11.85 127.50 18.30 133.70 C 24.74 139.91 30.62 155.43 41.00 151.00 C 46.88 148.49 64.54 139.14 61.00 132.00 C 57.63 125.22 48.49 118.11 44.08 111.92 C 39.67 105.72 33.31 96.11 27.00 92.00 C 25.63 92.92 24.59 91.06 24.00 91.00 C 14.96 92.20 8.86 102.30 0.00 104.00 M 45.00 128.00 C 53.29 130.18 49.75 145.74 40.33 142.67 C 30.91 139.60 35.49 125.49 45.00 128.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#E77721"
        stroke-opacity="0.55"
        stroke-width="0.3"
      >
        <path d="M 27.00 92.00 C 27.00 92.00 27.05 91.49 27.00 91.00 C 26.80 90.79 24.33 90.96 24.00 91.00 C 24.59 91.06 25.63 92.92 27.00 92.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#000000"
        stroke-opacity="0.00"
        stroke-width="0.3"
      >
        <path d="M 0.00 154.00 L 42.00 154.00 C 41.74 152.83 40.78 152.33 41.00 151.00 C 30.62 155.43 24.74 139.91 18.30 133.70 C 11.85 127.50 6.70 117.02 0.00 111.00 L 0.00 154.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#FEFAF8"
        stroke-opacity="1.00"
        stroke-width="0.3"
      >
        <path d="M 45.00 128.00 C 35.49 125.49 30.91 139.60 40.33 142.67 C 49.75 145.74 53.29 130.18 45.00 128.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B64601"
        stroke-opacity="0.50"
        stroke-width="0.3"
      >
        <path d="M 71.00 135.00 C 70.96 134.69 71.65 134.13 72.00 134.00 C 71.73 132.53 70.00 133.11 69.00 133.00 C 69.15 133.95 70.14 134.70 71.00 135.00 Z" />
      </g>
      <g
        fill="None"
        fill-opacity="0.0"
        stroke="#B54601"
        stroke-opacity="0.61"
        stroke-width="0.3"
      >
        <path d="M 44.00 154.00 L 48.00 154.00 C 47.58 152.43 44.47 152.66 44.00 154.00 Z" />
      </g>
      <g fill="#000000" fill-opacity="0.00" stroke="None">
        <path d="M 0.00 104.00 C 8.86 102.30 14.96 92.20 24.00 91.00 C 24.33 90.96 26.80 90.79 27.00 91.00 C 25.99 81.66 27.30 73.68 25.01 63.99 C 22.71 54.31 15.77 54.72 13.22 44.78 C 10.68 34.83 23.47 33.60 30.00 35.00 C 34.91 36.05 39.31 36.68 43.23 39.77 C 47.15 42.86 48.49 47.17 51.32 49.68 C 54.15 52.19 56.14 60.38 59.00 61.00 C 68.17 54.32 76.81 50.97 86.23 44.23 C 95.65 37.49 104.61 31.11 116.00 33.00 C 120.54 33.75 124.62 33.56 128.00 38.00 L 128.00 0.00 L 74.00 0.00 C 74.44 6.46 80.21 28.59 70.00 29.00 C 62.57 29.30 63.92 22.20 64.22 16.78 C 64.52 11.36 63.49 3.96 67.00 0.00 L 0.00 0.00 L 0.00 104.00 M 54.00 38.00 C 47.32 38.89 45.11 30.28 42.08 25.92 C 39.05 21.56 33.10 12.22 42.00 12.00 C 48.39 11.84 50.69 19.39 53.25 23.75 C 55.82 28.10 61.61 36.99 54.00 38.00 M 87.00 38.00 C 77.88 37.77 83.74 29.31 86.75 24.75 C 89.77 20.19 91.09 11.86 98.00 12.00 C 106.53 12.17 101.02 20.79 98.08 25.08 C 95.13 29.36 93.91 38.17 87.00 38.00 Z" />
      </g>
      <g fill="#FCCE40" fill-opacity="0.90" stroke="None">
        <path d="M 70.00 29.00 C 73.69 27.16 70.50 18.81 71.00 15.00 C 71.50 11.19 71.96 3.35 70.00 0.00 L 67.00 0.00 C 63.49 3.96 64.52 11.36 64.22 16.78 C 63.92 22.20 62.57 29.30 70.00 29.00 Z" />
      </g>
      <g fill="#BB4D03" fill-opacity="0.85" stroke="None">
        <path d="M 70.00 29.00 C 80.21 28.59 74.44 6.46 74.00 0.00 L 70.00 0.00 C 71.96 3.35 71.50 11.19 71.00 15.00 C 70.50 18.81 73.69 27.16 70.00 29.00 Z" />
      </g>
      <g fill="#FCCE3F" fill-opacity="0.89" stroke="None">
        <path d="M 54.00 38.00 C 54.20 34.13 51.86 26.57 49.08 23.92 C 46.29 21.28 45.32 13.06 42.00 12.00 C 33.10 12.22 39.05 21.56 42.08 25.92 C 45.11 30.28 47.32 38.89 54.00 38.00 Z" />
      </g>
      <g fill="#BA4C03" fill-opacity="0.83" stroke="None">
        <path d="M 54.00 38.00 C 61.61 36.99 55.82 28.10 53.25 23.75 C 50.69 19.39 48.39 11.84 42.00 12.00 C 45.32 13.06 46.29 21.28 49.08 23.92 C 51.86 26.57 54.20 34.13 54.00 38.00 Z" />
      </g>
      <g fill="#FCCD3F" fill-opacity="0.89" stroke="None">
        <path d="M 87.00 38.00 C 88.68 37.25 92.01 27.60 93.77 25.77 C 95.53 23.94 101.20 13.98 98.00 12.00 C 91.09 11.86 89.77 20.19 86.75 24.75 C 83.74 29.31 77.88 37.77 87.00 38.00 Z" />
      </g>
      <g fill="#B94C02" fill-opacity="0.79" stroke="None">
        <path d="M 87.00 38.00 C 93.91 38.17 95.13 29.36 98.08 25.08 C 101.02 20.79 106.53 12.17 98.00 12.00 C 101.20 13.98 95.53 23.94 93.77 25.77 C 92.01 27.60 88.68 37.25 87.00 38.00 Z" />
      </g>
      <g fill="#ECAD88" fill-opacity="0.98" stroke="None">
        <path d="M 59.00 61.00 C 52.83 65.49 53.85 67.91 49.22 59.78 C 44.59 51.64 38.76 40.04 30.00 35.00 C 23.47 33.60 10.68 34.83 13.22 44.78 C 15.77 54.72 22.71 54.31 25.01 63.99 C 27.30 73.68 25.99 81.66 27.00 91.00 C 27.05 91.49 27.00 92.00 27.00 92.00 C 33.31 96.11 39.67 105.72 44.08 111.92 C 48.49 118.11 57.63 125.22 61.00 132.00 C 71.19 134.61 82.50 122.24 90.75 118.75 C 98.99 115.25 114.67 104.57 102.00 97.00 C 105.72 91.81 104.09 83.98 98.00 81.00 C 100.99 74.98 97.07 66.19 90.00 66.00 C 98.32 55.18 126.78 50.81 116.00 33.00 C 104.61 31.11 95.65 37.49 86.23 44.23 C 76.81 50.97 68.17 54.32 59.00 61.00 Z" />
      </g>
      <g fill="#B74803" fill-opacity="0.91" stroke="None">
        <path d="M 61.00 132.00 C 64.54 139.14 46.88 148.49 41.00 151.00 C 40.78 152.33 41.74 152.83 42.00 154.00 L 44.00 154.00 C 44.47 152.66 47.58 152.43 48.00 154.00 L 49.00 154.00 C 55.13 147.32 72.45 145.34 71.00 135.00 C 70.14 134.70 69.15 133.95 69.00 133.00 C 70.00 133.11 71.73 132.53 72.00 134.00 C 81.18 130.68 92.89 127.25 100.89 120.89 C 108.90 114.54 123.92 108.63 112.00 98.00 C 114.63 92.71 114.15 85.49 108.00 83.00 C 109.38 76.85 107.34 69.81 101.00 67.00 C 109.16 59.61 120.80 55.49 128.00 47.00 L 128.00 45.00 C 126.57 43.97 126.31 39.96 128.00 39.00 L 128.00 38.00 C 124.62 33.56 120.54 33.75 116.00 33.00 C 126.78 50.81 98.32 55.18 90.00 66.00 C 97.07 66.19 100.99 74.98 98.00 81.00 C 104.09 83.98 105.72 91.81 102.00 97.00 C 114.67 104.57 98.99 115.25 90.75 118.75 C 82.50 122.24 71.19 134.61 61.00 132.00 Z" />
      </g>
      <g fill="#B84904" fill-opacity="0.90" stroke="None">
        <path d="M 59.00 61.00 C 56.14 60.38 54.15 52.19 51.32 49.68 C 48.49 47.17 47.15 42.86 43.23 39.77 C 39.31 36.68 34.91 36.05 30.00 35.00 C 38.76 40.04 44.59 51.64 49.22 59.78 C 53.85 67.91 52.83 65.49 59.00 61.00 Z" />
      </g>
      <g fill="#B64601" fill-opacity="0.67" stroke="None">
        <path d="M 128.00 45.00 L 128.00 39.00 C 126.31 39.96 126.57 43.97 128.00 45.00 Z" />
      </g>
      <g fill="#000000" fill-opacity="0.00" stroke="None">
        <path d="M 72.00 134.00 C 71.65 134.13 70.96 134.69 71.00 135.00 C 72.45 145.34 55.13 147.32 49.00 154.00 L 128.00 154.00 L 128.00 47.00 C 120.80 55.49 109.16 59.61 101.00 67.00 C 107.34 69.81 109.38 76.85 108.00 83.00 C 114.15 85.49 114.63 92.71 112.00 98.00 C 123.92 108.63 108.90 114.54 100.89 120.89 C 92.89 127.25 81.18 130.68 72.00 134.00 Z" />
      </g>
      <g fill="#E77723" fill-opacity="0.97" stroke="None">
        <path d="M 0.00 104.00 L 0.00 111.00 C 6.70 117.02 11.85 127.50 18.30 133.70 C 24.74 139.91 30.62 155.43 41.00 151.00 C 46.88 148.49 64.54 139.14 61.00 132.00 C 57.63 125.22 48.49 118.11 44.08 111.92 C 39.67 105.72 33.31 96.11 27.00 92.00 C 25.63 92.92 24.59 91.06 24.00 91.00 C 14.96 92.20 8.86 102.30 0.00 104.00 M 45.00 128.00 C 53.29 130.18 49.75 145.74 40.33 142.67 C 30.91 139.60 35.49 125.49 45.00 128.00 Z" />
      </g>
      <g fill="#E77721" fill-opacity="0.55" stroke="None">
        <path d="M 27.00 92.00 C 27.00 92.00 27.05 91.49 27.00 91.00 C 26.80 90.79 24.33 90.96 24.00 91.00 C 24.59 91.06 25.63 92.92 27.00 92.00 Z" />
      </g>
      <g fill="#000000" fill-opacity="0.00" stroke="None">
        <path d="M 0.00 154.00 L 42.00 154.00 C 41.74 152.83 40.78 152.33 41.00 151.00 C 30.62 155.43 24.74 139.91 18.30 133.70 C 11.85 127.50 6.70 117.02 0.00 111.00 L 0.00 154.00 Z" />
      </g>
      <g fill="#FEFAF8" fill-opacity="1.00" stroke="None">
        <path d="M 45.00 128.00 C 35.49 125.49 30.91 139.60 40.33 142.67 C 49.75 145.74 53.29 130.18 45.00 128.00 Z" />
      </g>
      <g fill="#B64601" fill-opacity="0.50" stroke="None">
        <path d="M 71.00 135.00 C 70.96 134.69 71.65 134.13 72.00 134.00 C 71.73 132.53 70.00 133.11 69.00 133.00 C 69.15 133.95 70.14 134.70 71.00 135.00 Z" />
      </g>
      <g fill="#B54601" fill-opacity="0.61" stroke="None">
        <path d="M 44.00 154.00 L 48.00 154.00 C 47.58 152.43 44.47 152.66 44.00 154.00 Z" />
      </g>
    </svg>
  );
};
export default EngagedIcon;
